import React from 'react';
import Slider from 'react-slick';
import './FoodCarousel.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import gourmentBurger from '../assets/food/gourmentBurger.png';
import nashvilleHotChickenSandwich from '../assets/food/nashvilleHotChickenSandwich.png';
import nyStripSteak from '../assets/food/nyStripSteak.png';
import chickenWings from '../assets/food/chickenWings.png';
import macNCheeseBalls from '../assets/food/macNCheeseBalls.png';
import bakedPasta from '../assets/food/bakedPasta.png';

const foodItems = [
  { image: gourmentBurger, name: 'Gourmet Burger' },
  { image: nashvilleHotChickenSandwich, name: 'Nashville Hot Chicken Sandwich' },
  { image: nyStripSteak, name: 'NY Strip Steak' },
  { image: chickenWings, name: 'Chicken Wings' },
  { image: macNCheeseBalls, name: 'Mac N Cheese Balls' },
  { image: bakedPasta, name: 'Baked Pasta' },
];

const NextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div
      className="custom-arrow custom-next-arrow"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '120px',
        right: '-60px',
        background: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        zIndex: 1000,
        cursor: 'pointer',
        border: '3px solid rgba(255, 255, 255, 0.8)',
        transition: 'all 0.3s ease'
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
    </div>
  );
};

const PrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div
      className="custom-arrow custom-prev-arrow"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '120px',
        left: '-60px',
        background: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        zIndex: 1000,
        cursor: 'pointer',
        border: '3px solid rgba(255, 255, 255, 0.8)',
        transition: 'all 0.3s ease'
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
    </div>
  );
};

const FoodCarousel: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  };

  return (
    <div className="food-carousel-section">
      <div className="container">
        <h2 className="text-center">Taste Our Menu</h2>
        <Slider {...settings}>
          {foodItems.map((item, index) => (
            <div key={index} className="carousel-slide">
              <img src={item.image} alt={item.name} className="carousel-image" />
              <h3 className="carousel-caption">{item.name}</h3>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default FoodCarousel; 